import { TimesHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const PutTimeData = (swimTimeId, timeObj, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const swimTimeIdForUrl = swimTimeId ? encodeURIComponent(swimTimeId) : 'NaN';
    const url = `/Time/${swimTimeIdForUrl}`;
    TimesHttpHelper(url, 'PUT', timeObj)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoaded: true,
            isSaved: true,
            isSaving: false,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoaded: false,
          isSaved: false,
          isSaving: false,
          message: message
        });
      });
  }
};

export default PutTimeData;